// SPDX-License-Identifier: AGPL-3.0-or-later
import {Logger} from '@app/features/platform/utils/AppLogger';
import {makeAutoObservable} from 'mobx';

const logger = new Logger('UserPinnedDM');
class UserPinnedDM {
	pinnedDMsArray: Array<string> = [];
	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}
	setPinnedDMs(pinnedDMs: Array<string>): void {
		this.pinnedDMsArray = pinnedDMs;
		logger.debug(`Set pinned DMs: ${pinnedDMs.length} channels`);
	}
	isPinned(channelId: string): boolean {
		return this.pinnedDMsArray.includes(channelId);
	}
	getPinIndex(channelId: string): number {
		return this.pinnedDMsArray.indexOf(channelId);
	}
	get pinnedDMs() {
		return this.pinnedDMsArray;
	}
}
export default new UserPinnedDM();
